<template>
    <div class="ui-form">
        <!-- 表单区 -->
        <div class="form-list">
            <a-row>
                <a-col :class="{'alert-item' : errKeys.indexOf(item.key) != -1,'textarea-col' : item.type == 'textarea'}" 
                        :span="item.colSpan || 12" v-for="(item,i) in fields" :key="i">
                    <div class="form-item clearfix" :class="{'disabled' : item.disabled}">

                        <div class="item-label fl">
                            <span class="red" v-if="validRules[item.key] && validRules[item.key].required">*</span>
                            <a-tooltip effect="dark" :content="item.label" placement="top">
                                <span>{{item.label}}</span>
                            </a-tooltip>
                        </div>
                        <div class="item-form fl" :class="{
                            'number' : item.type == 'number',
                            'has-unit' : item.unit
                        }">
                            <div class="alert-msg red" v-if="errKeys.indexOf(item.key) != -1 && errMsgs[item.key].msg">{{ errMsgs[item.key].msg }}</div>
                            <div class="item-form-input">
                                <template>
                                    <!-- 输入框 -->
                                    <a-input v-if="item.type === 'text'" 
                                            :disabled="item.disabled"
                                            @blur="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" :placeholder="item.placeholder || ''"></a-input>
                                    
                                    <!-- 密码输入框 -->
                                    <a-input v-if="item.type === 'password'" 
                                            type="password"
                                            :disabled="item.disabled"
                                            @blur="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" :placeholder="item.placeholder || ''"></a-input>
                                    
                                    <!-- 双输入框 -->
                                    <div class="double-input-box" v-if="item.type === 'doubleInput'" >
                                        <div class="left-input fl">
                                            <a-input 
                                                    :disabled="item.disabled"
                                                    @input="changeDoubleData(item.key)"
                                                    @blur="changeItemFn(item);validItem(item.key)"
                                                    v-model="formDatas[item.key + 'Start']" :placeholder="item.placeholder || ''"></a-input>
                                        </div>
                                        <div class="center-split">~</div>
                                        <div class="right-input fr">
                                            <a-input
                                                    :disabled="item.disabled"
                                                    @input="changeDoubleData(item.key)"
                                                    @blur="changeItemFn(item);validItem(item.key)"
                                                    v-model="formDatas[item.key + 'End']" :placeholder="item.placeholder || ''"></a-input>
                                        </div>
                                    </div>

                                    <!-- 单选框 -->
                                    <template v-if="item.type === 'radio'">
                                        <a-radio 
                                            :disabled="item.disabled"
                                            @change="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" :label="rItem.value" v-for="(rItem,i) in item.options" :key="i">{{rItem.label}}</a-radio>
                                    </template>

                                    <!-- 选择框 -->
                                    <a-select v-if="item.type === 'select' || item.type === 'dictionary'"  clearable
                                            :disabled="item.disabled"
                                            @click.native="clickItem(item)"
                                            :loading="item.loading"
                                            @change="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" :placeholder="item.placeholder || ''">
                                        <a-option
                                            v-for="oItem in item.options" :key="oItem.value"
                                            :label="oItem.label" :value="oItem.value">
                                        </a-option>
                                    </a-select>
                                    <!-- 多选择框 -->
                                    <a-select multiple v-if="item.type === 'multSelect'"  clearable
                                            :disabled="item.disabled"
                                            @change="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" :placeholder="item.placeholder || ''">
                                        <a-option
                                            v-for="oItem in item.options" :key="oItem.value"
                                            :label="oItem.label" :value="oItem.value">
                                        </a-option>
                                    </a-select>
                                    
                                    <!-- 开关按钮 -->
                                    <template v-if="item.type === 'switch'">
                                        <a-switch :disabled="item.disabled" v-model="formDatas[item.key]"></a-switch>
                                    </template>

                                    <!-- 远程查询选择框 -->
                                    <a-select v-if="item.type === 'remoteSelect'" size="mini" clearable
                                            :disabled="item.disabled"
                                            @change="changeItemFn(item);validItem(item.key)"
                                            filterable remote :remote-method="(key) => romoteQuery(key,item)"
                                            :loading="loadingObj[item.key]"
                                            v-model="formDatas[item.key]" :placeholder="item.placeholder || ''">
                                        <a-option
                                            v-for="oItem in (item.options || item.defaultOptions)" :key="oItem.value"
                                            :label="oItem.label" :value="oItem.value">
                                        </a-option>
                                    </a-select>

                                    <!-- 日期选择 -->
                                    <a-date-picker v-if="item.type === 'date'" 
                                            :disabled="item.disabled"
                                            @change="changeItemFn(item);validItem(item.key)"
                                            :name="item.key" v-model="formDatas[item.key]" type="date" :placeholder="item.placeholder || ''"></a-date-picker>

                                    <!-- 双日期选择 -->
                                    <a-date-picker class="item-form-double-date" v-model="formDatas[item.key]" v-if="item.type === 'doubleDate'" type="daterange" :start-placeholder="item.placeholder0" :end-placeholder="item.placeholder1" size="mini"></a-date-picker>
                                    
                                    
                                    <!-- 日期时间选择 -->
                                    <a-date-picker v-if="item.type === 'time'" 
                                            :disabled="item.disabled"
                                        v-model="formDatas[item.key]"
                                        type="datetime"
                                        placeholder="选择日期时间">
                                        </a-date-picker>

                                    <!-- 级联选择 -->
                                    <a-cascader v-if="item.type === 'cascader'" 
                                            :disabled="item.disabled"
                                            @change="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" :options="item.options"></a-cascader>
                                    
                                    <!-- 文本域 -->
                                    <a-input v-if="item.type === 'textarea'" 
                                            :disabled="item.disabled"
                                            type="textarea"
                                            resize="none"
                                            @blur="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" :placeholder="item.placeholder || ''"></a-input>
                                    <!-- 数字选择器 -->
                                    <a-input-number v-if="item.type === 'number'"  
                                            :disabled="item.disabled"
                                            @change="changeItemFn(item);validItem(item.key)"
                                            v-model="formDatas[item.key]" 
                                            :min="item.min" :max="item.max" 
                                            :label="item.placeholder || ''"></a-input-number>


                                </template>

                                <!-- <template v-if="item.disabled">
                                    <span v-if="item.type === 'date'">{{formDatas[item.key] | FormatDateFilter('date')}}</span>
                                    <span v-else-if="item.type === 'time'">{{formDatas[item.key] | FormatDateFilter('time')}}</span>
                                    <span v-else>{{formDatas[item.key]}}</span>
                                </template> -->
                            </div>
                            <div class="item-form-unit" v-if="item.unit">
                                {{item.unit}}
                            </div>
                        </div>

                    </div>
                </a-col>
            </a-row>
        </div>

        <!-- 按钮区 -->
        <div class="btn-list" v-if="btnFields && btnFields.length > 0">
            <div class="default-btn btn-item" :class="`${item.cssType} ${item.disabled ? 'disabled' : ''}`"
            v-loading="item.loading"
            v-for="(item,i) in btnFields" :key="i"
            @click="btnClick(item)"
            >
                <i v-if="item.icon" :class="item.icon"></i>
                <span>{{item.label}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { DictionaryService } from '@common/services/dictionary.service';
export default {
    name : 'UiForm',
    components : {
    },
    props : {
        // 表单设置列表
        formFields : {
            type : Array,
            default : () => []
        },
        // 数据字典项
        dicList : {
            type : Array,
            default : () => {return []}
        },
        // 表单验证
        validRules : {
            type : Object,
            default : () => ({})
        },
        // 按钮设置列表
        btnFields : {
            type : Array,
            default : () => []
        },
    },
    watch : {
        formFields : {
            immediate : true,
            handler (newVal, oldVal) {
                this.fields = newVal;
            }
        }
    },
    mounted () {
        // 获取数据字典并刷新
        this.$nextTick(() => this.refreshDicSt() );
    },
    data () {
        return {
            fields     : [],      // 配置项
            formDatas  : {},
            errKeys    : [],      //错误字段
            errMsgs    : {},      // 错误提示信息
            loadingObj : {},      // 远程搜索加载中
        }
    },
    methods : {
        // @public()
        // 设置数据
        setData (tarFormDatas) {
            this.formDatas = JSON.parse(JSON.stringify(tarFormDatas));
        },

        // 改变双输入框数据
        changeDoubleData (key) {
            this.formDatas[key] = [this.formDatas[key + 'Start'], this.formDatas[key + 'End']];
        },
        // 远程下拉列表获取
        romoteQuery (key,item) {
            this.$set(this.loadingObj,item.key,true);
            item.selectSearchFn(key,item).then(res => this.loadingObj[item.key] = false, 
                                                            err => this.loadingObj[item.key] = false);
        },

        // 单击某一项
        clickItem (item) {
            item.itemClickFn && item.itemClickFn(item);
        },

        // 数据改变触发回调
        changeItemFn (item) {
            if (item.key === 'coInsNo') this.refreshDicSt();   // 修改合作机构时，刷新项目编号、数据字典的下拉列表
            item.changeFn && item.changeFn(item,this.formDatas[item.key] || null);
        },

        // 修改合作机构时，刷新项目编号、数据字典的下拉列表
        async refreshDicSt () {
            if (!this.dicList || this.dicList.length == 0) return [];
            await this.refreshDic();
            this.refreshSt();
        },

        // 获取数据字典
        refreshDic () {
            if (!this.formDatas.coInsNo || !this.formDatas.coInsNo.value) return ;
            this.loading = true;
            return DictionaryService.getAllNeedDic(this.formDatas.coInsNo.value,this.dicList)
                        .catch((err) => this.$message.error('数据字典获取失败'))
                        .finally((fin) => this.loading = false)
        },

        // 数据字典刷新；项目刷新
        refreshSt () {
            this.fields.map(item => {
                if (item.type == 'dictionary') {
                    this.$set(this.formDatas, item.key, null);
                    let options = this.formDatas.coInsNo && this.formDatas.coInsNo.value ? DictionaryService.getOptions(item.dicKey) : [];
                    this.$set(item,'options',options);
                }
                if (item.type == 'index' && item.indexExt.type == 'project') this.$set(this.formDatas, item.key, null);
            })
        },

        // ------------------------------操作相关结束
        // 获取表单数据
        getFormData (formatFlag=true) {
            return JSON.parse(JSON.stringify(this.formDatas));
        },

        // 验证并获取表单数据
        getValidFormData (formatFlag=true) {
            return new Promise((resolve,reject) => {
                this.validForm().then((res) => {
                    resolve( JSON.parse(JSON.stringify(this.formDatas)) );
                },(err) => {
                    reject(err);
                });
            })
        },

        // 验证规则
        validRuleFn (key, regRule, val) {
            if (!regRule) return true;
            this.errMsgs[key] = {};
            let errFlag = false;
            // 必填校验
            if (!errFlag) errFlag = regRule.required && !val;
            // 数字校验
            if (!errFlag) errFlag = regRule.number && val && isNaN(val);
            // 其它校验
            if (!errFlag) errFlag = regRule.validFn && ( this.errMsgs[key].msg = regRule.validFn(val) );

            return errFlag;
        },

        // 验证单项
        validItem (key) {
            let regRule = this.validRules[key];
            if (!regRule) return ;

            // 验证
            let errFlag = this.validRuleFn(key, regRule, this.formDatas[key]);

            // 未通过校验
            if (errFlag) this.errKeys.push(key);
            // 通过校验
            if (!errFlag) (this.errKeys = this.errKeys.filter(item => item != key));
            this.errKeys = Array.from(new Set(this.errKeys));
        },

        // @public
        // 验证表单
        validForm () {
            return new Promise((resolve,reject) => {
                this.errKeys = [];
                Object.keys(this.validRules).map(item => {
                    let regRule = this.validRules[item];
                    if (!regRule) return ;

                    // 验证
                    let errFlag = this.validRuleFn(item, regRule, this.formDatas[item]);
                    
                    // 未通过校验
                    if (errFlag) this.errKeys.push(item);
                })
                // 去重
                this.errKeys = Array.from(new Set(this.errKeys));
                if (this.errKeys.length > 0) reject(this.errKeys);
                else resolve(true);
            });
        },
        
        // @public
        // 重置参数
        reset () {
            this.formDatas = {}
        },

        // @public
        // 获取某一项的值
        getItemVal (key) {
            return this.formDatas[key];
        },

        // @public
        // 改变某一项的数值
        changeItemVal (key, val) {
            this.$set(this.formDatas,key,val)
        },

        // 按钮点击事件
        async btnClick (item) {
            this.$set(item,'loading',true);
            !item.disabled && item.run && await item.run();
            this.$set(item,'loading',false);
        },

    }
}
</script>

<style lang="less" scoped>
.ui-form{
    // 表单区
    .form-list{
        color:#666666;
        // border: 1px solid #EFEFEF;
        padding:20px;
        .a-col{
            border:1px solid #fff;
            &.alert-item{
                border:1px solid #f00;
            }
            // 文本域
            &.textarea-col{
                height:120px;
                .form-item{
                    height:120px;
                }
                .item-form{
                    height:120px !important;
                    .item-form-input{
                        height:100%;
                    }
                    .a-textarea{
                        height:100% !important;
                        /deep/ textarea{
                            width:100%;
                            height:100%;
                            border:0;
                        }
                    }
                }
            }
            .form-item{
                padding-bottom:10px;
                .item-label{
                    width:200px;
                    height:32px;
                    display:inline-block;
                    text-align: right;
                    line-height:32px;
                    padding-right:14px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color:#44495A;
                    font-size:12px;
                    .red{
                        margin-right:5px;
                    }
                }
                &.disabled{
                    .item-form,.item-form /deep/ input{
                        background:#EFEFEF;
                    }
                }
                .item-form{
                    width:calc(100% - 200px);
                    height:32px;
                    line-height:30px;
                    display:inline-block;
                    position:relative;
                    padding-left:10px;
                    border:1px solid #E0E2E9;
                    border-radius:4px;
                    /deep/ .a-input.is-disabled .a-input__inner{
                        background:#EFEFEF;
                    }
                    // 有单位
                    &.has-unit{
                        display: flex;
                        .item-form-input{
                            width:100%;
                        }
                        .item-form-unit{
                            display:inline-block;
                            white-space: nowrap;
                            padding:0 10px;
                        }
                    }
                    // 数字选择器
                    &.number{
                        padding-left:0;
                        .item-form-input{
                            line-height:1;
                            .a-input-number{
                                height:32px;
                                line-height:30px;
                            }
                        }
                    }
                    // 索引
                    .index-box{
                        border:0;
                    }
                    // 双日期选择
                    .item-form-double-date{
                        width:100%;
                        padding: 0 10px;
                        border:0;
                        /deep/ input{
                            height:28px;
                            padding-right:10px;
                        }
                        /deep/ .a-input__icon{
                            display:inline-block;
                            width:44px;
                            vertical-align: top;
                        }
                        /deep/ .a-range-separator{
                            line-height:28px;
                        }
                    }
                    
                    // 错误提示信息
                    .alert-msg{
                        position:absolute;
                        right:0;
                        bottom:0;
                        padding-right:5px;
                        z-index: 10;
                        font-size:12px;
                    }
                    
                    // form输入区域
                    .item-form-input{
                        line-height: 30px;
                        /deep/ .a-input,/deep/ .a-select,/deep/ .a-input-number,/deep/ .a-cascader,/deep/ input{
                            width:100%;
                            height:30px;
                            line-height:30px;
                            border:0;
                        }
                        // 双输入框
                        .double-input-box{
                            position:relative;
                            .left-input,.right-input{
                                width:40%;
                            }
                            .center-split{
                                position:absolute;
                                left:40%;
                                right:40%;
                                text-align: center;
                                color:#44495A;
                            }
                        }
                        // 下拉框
                        .a-select{
                            height:29px;
                            line-height:29px;
                        }
                        // 图标位置
                        /deep/ .a-input__icon{
                            line-height:29px;
                        }
                    }
                }
            }
        }
    }

    // 按钮区
    .btn-list{
        width:100%;
        min-height:40px;
        line-height:40px;
        text-align: center;
        font-size:12px;
        padding:10px 0;
        .btn-item{
            min-width:60px;
            height:38px;
            text-align: center;
            line-height: 36px;
            padding:0 20px;
            display:inline-block;
            border:1px solid #DCDFE6;
            margin-right: 10px;
            border-radius:5px;
            cursor: pointer;
            &.disabled{
                opacity: 0.3;
                cursor:not-allowed;
            }
            &:hover{
                color:#409EFF;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
            }
            &.primary{
                background:#409EFF;
                border-color:#409EFF;
                color:#fff;
                &:hover{
                    background:#66b1ff;
                    border-color:#66b1ff;
                }
            }
            &:nth-last-child(1) {
                margin-right:0;
            }
        }
    }
}
</style>